import { provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';

/**
 * `provideZoneChangeDetection` e obrigatorio aqui, nao opcional.
 *
 * A partir do Angular 22 o `bootstrapModule` nao configura mais deteccao de
 * mudancas por NgZone sozinho: sem este provider a aplicacao sobe em modo
 * zoneless, e ai so os listeners declarados no template marcam a view como
 * suja. Resposta de HTTP, `setTimeout` e `setInterval` deixam de disparar
 * renderizacao -- o modelo e atualizado e a tela continua mostrando o estado
 * anterior ate o usuario clicar em alguma coisa.
 *
 * Era o que acontecia nas telas de Certificados depois do upgrade:
 * `sites-ativos` carregava os 23 sites e o `console.log` do componente provava
 * que o modelo estava populado, mas os KPIs ficavam em 0, a tabela vazia e o
 * spinner preso na tela. O `dashboard` tinha o mesmo sintoma.
 *
 * O `ngZoneEventCoalescing: true` que estava aqui vinha do `BootstrapOptions`,
 * que esta deprecado e nao liga o NgZone; o equivalente suportado e a opcao
 * `eventCoalescing` deste provider, preservada abaixo.
 */
platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    applicationProviders: [provideZoneChangeDetection({ eventCoalescing: true })]
  })
  .catch(err => console.error(err));
